
<!-- Need to Load only splash screen if language has not been set in local storage -->
<country-language-selector  *ngIf="canLoadSplashScreenInitally && !isPromotion"></country-language-selector>

<!-- App layout will be displayed only when language and country stored in local storage -->
<app-layout *ngIf="!canLoadSplashScreenInitally && !isPromotion"></app-layout>
<router-outlet *ngIf="isPromotion"></router-outlet>

<!--Session Tieout Modal Popup Start -->
<div tabindex="0" aria-label="session Timeout confirmation popup" bsModal #sessionTimeoutModal="app-modal"
    [config]="{ignoreBackdropClick: true, keyboard:false, backdrop:false}" style="background-color: rgba(0, 0, 0, 0.5);" 
    class="modal fade bs-example modal--center">
    <div class="modal-dialog" style="top: 50%;transform: translateY(-50%);margin: 0 auto;">
        <div class="modal-content p-2">
            <div class="modal-header">
                <div class="session-header helvetica-bold">{{'common.Session Inactivity Alert' | translate | translateKey}}</div>
            </div>
            <div class="modal-body">
                {{'common.You will be logged out automatically in' | translate | translateKey}} <span id="counter">{{idleState}}</span>
                {{'common.seconds. Please click the button below to continue working.' | translate | translateKey}}
            </div>
            <div class="modal-footer">
                <button role="button" aria-label="yes" type="button" (click)="stay()" class="btn btn-primary"
                    id="modal-btn-no">{{'common.Continue Working' | translate | translateKey}}</button>
            </div>
        </div>
    </div>
</div>
<!--Session Tieout Modal Popup End -->
